import styled from 'styled-components';
const percentageSize = 1.3;

export const CapaLlegendaSVG24 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const CapaLlegendaSVG16 = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 16 * percentageSize : 16,
  height: props.fontSizeEnabled ? 16 * percentageSize : 16
}))``;
